export default __webpack_public_path__ + "static/media/retail-image-5b5292.4c0f59ac.png";